export default function SignOut() {
  return (
    <div>SignOut</div>
  )
}
